/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReportScheduleDto } from '../../models/report-schedule-dto';

export interface ReportSchedulesGet$Plain$Params {
}

export function reportSchedulesGet$Plain(http: HttpClient, rootUrl: string, params?: ReportSchedulesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReportScheduleDto>>> {
  const rb = new RequestBuilder(rootUrl, reportSchedulesGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ReportScheduleDto>>;
    })
  );
}

reportSchedulesGet$Plain.PATH = '/report-schedules';
